import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { raiseToast } from '../toast/toast'

import { searchBuyerRequirements } from '../../../api/postRequirement'
import { getMaterialItemsDataByBuyerReqItemIds } from '../../../api/buyerReqItem'
import { getBuyerReqsBySmartSearch, getRequirementRelatedDetailsByBuyerReqIds } from '../../../api/buyerReq'
import { getSearchActiveStatus } from '../../../../utils'


export const fetchRequirement = createAsyncThunk('user/getRequirement', async (params, { dispatch }) => {
    let response = []
    if (params.isSmartSearchApplicable){
        response = await getBuyerReqsBySmartSearch(params)
    }else{
        response = await searchBuyerRequirements(params)
    }

    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: 'Requirement', detail: response.data.error, life: 3000}))
        throw Error()
    }
    return response
})

export const fetchMaterialsData = createAsyncThunk('user/getMaterials', async (data) => {
    const response = await getMaterialItemsDataByBuyerReqItemIds(data)
    // console.log("Res materials", response)
    return response.data
})

export const fetchReqRelatedData = createAsyncThunk('user/getReqRelatedData', async (data) => {
    const response = await getRequirementRelatedDetailsByBuyerReqIds(data)
    console.log("getRequirementRelatedDetailsByBuyerReqIds", response)
    return response.data
})

export const requirementSlice = createSlice({
    name: "user/getRequirement",
    initialState: {
        loading: false ,
        reqDataLoading: false,
        isInitialLoad: true,
        buyerRequirementData : [],
        sellerReqData: {},
        buyerQuoteData: {},
        buyerPOData: {},
        poPunchData: {},
        poScheduleData: {},
        sellerPOData: {},
        piPunchData: {},
        approvalInstancesData: [],
        // sellerGRNQCPunchData: [],
        // sellerGRNQCLoading: false,
        buyerRequirementItemsData: [],
        materialProductsData: [],
        materialProductsLoading : false,
        selectedBuyerQuoteId: null,
        selectedBuyerPO: null,
        selectedBuyerPODocNo: null,
        selectedBuyerPOId: null,
        selectedSellerPO: null,
        paginationParams : {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true,
            paginator: true
        },
        searchParams: {
            dataType: "requirementData",
            productType: "",
            searchBy: "all",
            searchText: "",
            dateType: "createdAt"
        },
        searchOptions: [],
        isSearchVisible: false,
        isSearchActive: true,
        searchConfig: []
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
            const parsedState = JSON.parse(JSON.stringify(state))

            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)

            state.isSearchActive = isSearchActive
        },
        updateBuyerRequirementData: (state, action) => {
            state.buyerRequirementData = action.payload
        },
        updateBuyerRequirementItemsData: (state, action) => {
            state.buyerRequirementItemsData = action.payload
        },
        deleteRequirement: (state, action) => {
            state.buyerRequirementData = action.payload
        },
        setBuyerQuotesData: (state, action) => {
            state.buyerQuoteData = action.payload
        },
        setSelectedBuyerQuoteId: (state, action) => {
            state.selectedBuyerQuoteId = action.payload
        },
        setSelectedBuyerPO: (state, action) => {
            state.selectedBuyerPO = action.payload
        },
        setSelectedBuyerPODocNo: (state, action) => {
            state.selectedBuyerPODocNo = action.payload
        },
        setSelectedBuyerPOId: (state, action) => {
            state.selectedBuyerPOId = action.payload
        },
        setSellerPOsData: (state, action) => {
            state.sellerPOData = action.payload
        },
        setSelectedSellerPO: (state, action) => {
            state.selectedSellerPO = action.payload
        },
        deleteQuote: (state, action) =>{
            state.buyerQuoteData = action.payload
        },
        deleteBuyerPO: (state, action) =>{
            state.buyerPOData = action.payload
        },
        deleteSellerPO: (state, action) =>{
            state.sellerPOData = action.payload
        },
        resetReqData: (state, action) => {
            state.sellerReqData = {sellerReqs: [], sellerReqItems: []}
            state.buyerQuoteData = {buyerQuotes: [], buyerQuoteItems: []}
            state.buyerPOData = {buyerPOs: [], buyerPOItems: []}
            state.poScheduleData = {poSchedules: [], poScheduleItems: []}
            state.poPunchData = {poPunch: [], poPunchItems: []}
            state.sellerPOData = {sellerPOs: [], sellerPOItems: []}
            state.piPunchData = {sellerPIPunch: [], sellerPIPunchItems: []}
            state.approvalInstancesData = []
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchRequirement.fulfilled, (state, action) => {
                state.loading = false
                state.buyerRequirementData  = action.payload.data.data
                state.buyerRequirementItemsData = action.payload.data.buyerReqItems
                // state.materialProductsData = action.payload.data.materialProducts
                state.paginationParams.pageNo = action.payload.data.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.data.recordsPerPage
                if(action.payload.data.totalRecords || action.payload.data.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.data.totalRecords
                }
                if(action.payload.data.excessPagesFound || !action.payload.data.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.data.excessPagesFound
                    }else if(action.payload.data.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
                //state.isSearchVisible = false
            }
        )
        .addCase(
            fetchRequirement.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchRequirement.rejected, (state, action) => {
                state.loading = false
                state.buyerRequirementData  =  []
                state.paginationParams.totalRecords =  0
            }
        )
        .addCase(
            fetchMaterialsData.fulfilled, (state, action) => {
                state.materialProductsLoading = false 
                state.materialProductsData = action.payload
            }
        )
        .addCase(
            fetchMaterialsData.pending, (state, action) => {
                state.materialProductsLoading = true 
            }
        )
        .addCase(
            fetchMaterialsData.rejected, (state, action) => {
                state.materialProductsLoading = false
            }
        )
        .addCase(
            fetchReqRelatedData.fulfilled, (state, action) => {
                let sellerReqData = {sellerReqs: action.payload.sellerReqs || [], sellerReqItems: action.payload.sellerReqItems || []}
                let buyerQuoteData = {buyerQuotes: action.payload.buyerQuotes || [], buyerQuoteItems: action.payload.buyerQuoteItems || []}
                let buyerPOData = {buyerPOs: action.payload.buyerPOs || [], buyerPOItems: action.payload.buyerPOItems || []}
                let poScheduleData = {poSchedules: action.payload.poSchedules || [], poScheduleItems: action.payload.poScheduleItems || []}
                let poPunchData = {poPunch: action.payload.poPunches || [], poPunchItems: action.payload.poPunchItems || []}
                let sellerPOData = {sellerPOs: action.payload.sellerPOs || [], sellerPOItems: action.payload.sellerPOItems || []}
                let piPunchData = {sellerPIPunch: action.payload.sellerPIPunches || [], sellerPIPunchItems: action.payload.sellerPIPunchItems || []}

                let approvalInstancesData = action.payload.approvalInstances || []

                state.reqDataLoading = false 
                state.sellerReqData = sellerReqData
                state.buyerQuoteData = buyerQuoteData
                state.buyerPOData = buyerPOData
                state.poScheduleData = poScheduleData
                state.poPunchData = poPunchData
                state.sellerPOData = sellerPOData
                state.piPunchData = piPunchData
                state.approvalInstancesData = approvalInstancesData
            }
        )
        .addCase(
            fetchReqRelatedData.pending, (state, action) => {
                state.reqDataLoading = true 
            }
        )
        .addCase(
            fetchReqRelatedData.rejected, (state, action) => {
                state.reqDataLoading = false
            }
        )
    }
})

export const { updateSearchParams, updateSearchOptions, deleteRequirement, setBuyerQuotesData, setSelectedBuyerQuoteId, setSelectedBuyerPO, setSelectedBuyerPODocNo, setSelectedBuyerPOId, setSellerPOsData, setSelectedSellerPO, deleteQuote, deleteBuyerPO, deleteSellerPO, updateBuyerRequirementData, updateBuyerRequirementItemsData, resetReqData, setInitialLoad, setIsSearchVisible, setSearchConfig } = requirementSlice.actions

export default requirementSlice.reducer